import React from 'react';

const TimeSlot = ({ hour, showTime, bottomHour }) => {
  return (
    <div className="timeSlot">
      {showTime && (
        <div className="timeLabel">
          {hour}:00
        </div>
      )}
      {bottomHour && (
        <div className="timeLabel -bottom">
          {hour + 1}:00
        </div>
      )}
    </div>
  );
};

export default TimeSlot;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/TimeSlot.js